import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.query-builder.query-block.contexts`, {
  'query-builder.context-menu.automatically-created': `Automatically created by Mixpanel`,
  'query-builder.events-menu.section-all-events': `All Events`,
  'query-builder.events-menu.section-recent-events': `Recents`,
  'query-builder.events-menu.section-suggested-events': `Suggested Events`,
  'query-builder.events-menu.section-suggested-events-info': `These suggestions have been made by AI and are based on your project's Lexicon data.`,
  'query-builder.metrics.custom-event': `Custom Event`,
});
